import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Welcome")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Enter your name")
const _hoisted_5 = { class: "py-4 container-fluid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pb-0" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Lojas")
], -1)
const _hoisted_10 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_11 = { class: "table-responsive p-0" }
const _hoisted_12 = { class: "table align-items-center mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs" }, "ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Loja"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" }),
    /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" })
  ])
], -1)
const _hoisted_14 = { class: "text-secondary opacity-7" }
const _hoisted_15 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_16 = { class: "text-secondary opacity-7" }
const _hoisted_17 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_18 = { class: "mb-0 text-sm" }
const _hoisted_19 = { class: "text-xs text-secondary mb-0" }
const _hoisted_20 = { class: "align-middle text-center text-sm" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", { class: "align-middle text-center text-sm" }, null, -1)
const _hoisted_22 = { class: "text-sm text-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-eye text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "mx-3",
  "data-bs-toggle": "tooltip",
  "data-bs-original-title": "Edit product"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-user-edit text-secondary",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  "data-bs-toggle": "tooltip",
  "data-bs-original-title": "Delete product"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-trash text-secondary",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_27 = { class: "dataTable-bottom" }
const _hoisted_28 = { class: "dataTable-info" }
const _hoisted_29 = { class: "dataTable-pagination" }
const _hoisted_30 = { class: "dataTable-pagination-list" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-page": "1"
}, "1", -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-page": "2"
}, "2", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-page": "3"
}, "3", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  "data-page": "2"
}, "›", -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_modal, {
      ref: "modal",
      "is-open": _ctx.edit_loja,
      onWillDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit_loja=false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_buttons, { slot: "end" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      strong: true,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirm()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, { class: "ion-padding" }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  ref: "input",
                  type: "text",
                  placeholder: "Your name"
                }, null, 512)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtos, (produto) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: _ctx.produtos.id
                      }, [
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(produto.id), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("h6", _hoisted_18, _toDisplayString(produto.nome), 1),
                              _createElementVNode("p", _hoisted_19, _toDisplayString(produto.cidade), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _createVNode(_component_ion_toggle, {
                            modelValue: produto.ativo,
                            "onUpdate:modelValue": ($event: any) => ((produto.ativo) = $event),
                            "enable-on-off-labels": true
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _hoisted_21,
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("a", {
                            href: "javascript:;",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editar())),
                            "data-bs-original-title": "Preview product"
                          }, _hoisted_24),
                          _hoisted_25,
                          _hoisted_26
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, "Mostrando " + _toDisplayString(_ctx.current_page) + " ate " + _toDisplayString(_ctx.current_page+10) + " de " + _toDisplayString(_ctx.total_pages) + " produtos", 1),
            _createElementVNode("nav", _hoisted_29, [
              _createElementVNode("ul", _hoisted_30, [
                _createElementVNode("li", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getProdutos(_ctx.current_page+10))),
                  class: "active"
                }, _hoisted_32),
                _createElementVNode("li", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getProdutos(_ctx.current_page+20))),
                  class: ""
                }, _hoisted_34),
                _createElementVNode("li", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getProdutos(_ctx.current_page+30))),
                  class: ""
                }, _hoisted_36),
                _createElementVNode("li", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getProdutos(_ctx.current_page+10))),
                  class: "pager"
                }, _hoisted_38)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}